import { type QueryHookOptions, useQuery } from "@apollo/client";
import { AnalyticsViewsByDateQuery } from "../graphql/queries";
import type {
  AnalyticsViewsByDateQueryType,
  AnalyticsViewsByDateQueryVariablesType,
} from "@/types/graphql/partner.generated";

export const useAnalyticsViewsByDateQuery = (
  options?: QueryHookOptions<
    AnalyticsViewsByDateQueryType,
    AnalyticsViewsByDateQueryVariablesType
  >
) => {
  return useQuery<
    AnalyticsViewsByDateQueryType,
    AnalyticsViewsByDateQueryVariablesType
  >(AnalyticsViewsByDateQuery, options);
};
